import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { INTEGRATION_SETTING_SOURCE } from 'stores/integrationSettingsStore';
import './IntegrationSettingSourceBadge.scss';

const IntegrationSettingSourceBadge = ({ source }) => {
  const i18n = useContext(i18nContext);
  const isCustomized = source === INTEGRATION_SETTING_SOURCE.DATABASE;

  return (
    <span className={`integration-setting-source-badge ${isCustomized ? 'customized' : 'defaults'}`}>
      {i18n.getMessage(`settings.integrations.source.${isCustomized ? 'customized' : 'defaults'}`)}
    </span>
  );
};

IntegrationSettingSourceBadge.propTypes = {
  source: PropTypes.string
};

export default IntegrationSettingSourceBadge;
